@import (reference) '../../../../constants/spacing.module.less';

.overview-navigation {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-16;
  margin-bottom: @space-16;
}

.overview-icon {
  height: 16px;
  color: var(--default--icon--fill-color--11);
}

.divider {
  border-bottom: solid 1px var(--default--border-color--10);
}
